import { analytics } from '@play-co/gcinstant';
import GCInstant from '@play-co/gcinstant';
import StateObserver from 'src/StateObserver';

////////////////////////////////////////////////////////////////////////////////
// The player has collected a gift energy from a LINE friend
////////////////////////////////////////////////////////////////////////////////
export function trackGiftCollect({
  gift,
  amount,
  sender,
}: {
  gift: string; // energy
  amount: number;
  sender: string;
}) {
  analytics.pushEvent('GiftCollect', {
    gift,
    amount,
    sender,
  });
}
